import React from 'react'
import { useColours } from '@confer/lib'
import { LogosProps } from './Interfaces'
import styled from 'styled-components'

interface MobileBannerProps {
  isVisible: boolean
  logos?: LogosProps
}

export const MobileBanner = (props: MobileBannerProps) => {
  const { logos } = props

  const { primaryColour, backgroundColour } = useColours()

  let logo: string = ''
  let alt: string = ''
  let isWhite: boolean = false
  if (logos && logos.logos[0]) {
    logo = logos.logos[0].whitePath ?? logos.logos[0].path
    alt = logos.logos[0].altText ?? 'logo'
    isWhite = logos.logos[0].whitePath ? true : false
  }

  return (
    <Container
      isVisible={props.isVisible}
      bgcolour={isWhite ? primaryColour : 'var(--mid-light-2)'}
      $padding={logos?.logos[0]?.padding}
    >
      <LogoContainer isWhite={isWhite} bgColour={backgroundColour}>
        <img src={logo} alt={alt} />
      </LogoContainer>
    </Container>
  )
}

const Container = styled.div<{ bgcolour: string; isVisible: boolean; $padding?: string }>`
  /* height: 64px; */
  /* padding: var(--spacing-sm); */
  height: ${(props) => (props.isVisible ? '64px' : '0px')};
  padding: ${(props) => (props.isVisible ? props.$padding ?? 'var(--spacing-sm)' : '0px')};
  transition:
    height 0.5s ease-in-out 0s,
    padding 0.5s ease-in-out 0s;
  width: 100vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;

  background-color: ${(props) => props.bgcolour};
`

const LogoContainer = styled.div<{ isWhite: boolean; bgColour: string }>`
  display: flex;
  flex: 0 1;
  flex-direction: row;
  justify-content: center;
  /* background-color: ${(props) => (props.isWhite ? 'transparent' : props.bgColour)}; */
  img {
    object-fit: contain;
    height: 100%;
  }
`
